import React from "react";
import moment from "moment";
import { useApplication } from "../../contexts/ApplicationContext";

const HeaderQuery = ({
  title,
  type = "default",
  hasHeader = true,
  date = "",
  document = "",
  hasRestrictions = null,
  logoURL = "",
  protocol = null,
}) => {
  const { user } = useApplication();

  let logoSrc;

  switch (true) {
    case window.location.href.includes("avaliecreditoconsultas"):
      logoSrc = "/assets/white-label/avalie-credito/logo.png";
      break;
    case window.location.href.includes("acessopositivo"):
      logoSrc = "/assets/white-label/acesso-positivo/logo-azul.png";
      break;
    case window.location.href.includes("proconsultbr"):
      logoSrc = "/assets/white-label/pro-consult-br/logo_consult.png";
      break;
    case window.location.href.includes("simscore"):
      logoSrc = "/assets/white-label/sim-pesquisa/logo_sim.png";
      break;
    case window.location.href.includes("simpesquisa"):
      logoSrc = "/assets/white-label/sim-pesquisa/logo_sim.png";
      break;
    case window.location.href.includes("credoresbrasil"):
      logoSrc = "/assets/white-label/credores-brasil/logo.png";
      break;
    case window.location.href.includes("consultaspositivo"):
      logoSrc = "/assets/white-label/consultas-positivo/logo.png";
      break;
    case window.location.href.includes("raioxconsultas"):
      logoSrc = "/assets/white-label/raio-x/logo.png";
      break;
    case window.location.href.includes("obahcredito"):
      logoSrc = "/assets/white-label/obah-credito/logo.png";
      break;
    case window.location.href.includes("hellusconsultoria"):
      logoSrc = "/assets/white-label/hellus-consultoria/logo.png";
      break;
    case window.location.href.includes("nomenoazul"):
      logoSrc = "/assets/white-label/nome-no-azul/logo.png";
      break;
    case window.location.href.includes("finposcore"):
      logoSrc = "/assets/white-label/finpo-score/logo.png";
      break;
    default:
      logoSrc = "/assets/relinq_1.png";
      break;
  }

  return (
    <>
      {hasHeader && (
        <>
          <div
            className={`flex flex-row justify-between text-end gap-2 mb-1 items-center`}
          >
            <div>
              {user?.Company?.showLogo && (
                <img src={logoSrc} className="w-40 mb-4" />
              )}
            </div>

            <div className="flex gap-1 items-center">
              <div className="flex gap-2 items-end">
                {logoURL && <img className="w-14" src={logoURL} />}
                <div className="flex flex-col gap-1">
                  <div className="font-semibold text-2xl">{title}</div>
                  <div className="italic text-sm">
                    {date && (
                      <span>
                        <b className="font-semibold">Data:</b> {date}
                      </span>
                    )}
                    {protocol && (
                      <span className="inline-block ml-4">
                        <b className="font-semibold">Protocolo:</b> {protocol}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default HeaderQuery;
